/**
 * The Avengents mark, inlined.
 *
 * Same geometry as public/icon.svg (the app icon, drawn identically by
 * scripts/generate-app-icons.py) — a rounded tile holding the agent rail (three
 * dots on a line) and a terminal prompt. Inlined rather than <img src> for the
 * reason every glyph in this app is self-hosted: the tailnet has no CDN and the
 * mark must paint even if the network is gone (docs/UI-COMPONENTS.md §4.2).
 *
 * The outer full-bleed background square from the icon file is dropped here so
 * the corners are transparent and the rounded tile sits on whatever chrome hosts
 * it. Decorative: callers put the readable "Avengents" wordmark beside it, so
 * this is aria-hidden.
 */
export function AvengentsMark({ size = 22 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      /*
       * Cropped to the mark's own bounds (the tile spans 221–803 × 205–819 of
       * the 1024 icon canvas). The full-canvas viewBox left ~20% transparent
       * margin, so a 22px render drew a tiny tile — owner, 2026-08-09: Icon
       * 太小，讓他的高度貼齊 header bar. Now `size` IS the visible height.
       */
      viewBox="202 196 620 632"
      aria-hidden="true"
      focusable="false"
      style={{ flex: '0 0 auto', display: 'block' }}
    >
      <path
        d="M221 332c0-70.1 56.9-127 127-127h328c70.1 0 127 56.9 127 127v360c0 70.1-56.9 127-127 127H348c-70.1 0-127-56.9-127-127V332Z"
        fill="#181825"
      />
      <path
        d="M348 229h328c56.8 0 103 46.2 103 103v360c0 56.8-46.2 103-103 103H348c-56.8 0-103-46.2-103-103V332c0-56.8 46.2-103 103-103Z"
        fill="none"
        stroke="#45475a"
        strokeWidth="48"
      />
      <path d="M353 377v270" stroke="#585b70" strokeWidth="42" strokeLinecap="round" />
      <circle cx="353" cy="377" r="56" fill="#a6e3a1" />
      <circle cx="353" cy="512" r="56" fill="#cba6f7" />
      <circle cx="353" cy="647" r="56" fill="#89b4fa" />
      <path
        d="M499 396 639 512 499 628"
        fill="none"
        stroke="#cdd6f4"
        strokeWidth="72"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M654 646h96" stroke="#89dceb" strokeWidth="72" strokeLinecap="round" />
    </svg>
  )
}
